export default __webpack_public_path__ + "static/media/failed.dc96e6e1.svg";